// Thin client for POST /api/v2/learning_events (spec §3.2).
//
// Semantic events are supplementary to the beat-driven active-time counters,
// so a failed send is swallowed: it never affects accumulated active time,
// and the server treats a client_event_id resend as an idempotent no-op.

export const EVENTS_ENDPOINT = '/api/v2/learning_events'

export interface LearningEventInput {
  lessonId: number
  sessionUuid: string
  eventType: string
  payload?: Record<string, unknown>
}

export type EventsTransport = (body: unknown) => Promise<void>

export function defaultEventsTransport(): EventsTransport {
  return async (body) => {
    const res = await fetch(EVENTS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
    if (!res.ok) throw new Error(`learning_events failed: ${res.status}`)
  }
}

export async function sendLearningEvent(
  input: LearningEventInput,
  transport: EventsTransport = defaultEventsTransport(),
  uuid: () => string = () => crypto.randomUUID()
): Promise<void> {
  if (!input.sessionUuid || !input.lessonId) return

  const body = {
    events: [{
      client_event_id: uuid(),
      session_uuid: input.sessionUuid,
      lesson_id: input.lessonId,
      event_type: input.eventType,
      occurred_at: new Date().toISOString(),
      schema_version: 1,
      payload: input.payload ?? {}
    }]
  }

  try {
    await transport(body)
  } catch {
    // best-effort; see module comment
  }
}
